(function () {
  var BUTTON_SELECTOR = "[data-babylist-button]";
  var SCRIPT_SRC = "https://www.babylist.com/add.js";
  var scriptPromise = null;

  /* Babylist's add.js is loaded on demand at first click — zero cost
     for visitors who never use the button. */
  function loadBabylist(partner) {
    if (window.bl && typeof window.bl.addToRegistry === "function") {
      return Promise.resolve();
    }

    if (!scriptPromise) {
      scriptPromise = new Promise(function (resolve, reject) {
        window._bl = window._bl || { partner: partner };

        var script = document.createElement("script");
        script.async = true;
        script.src = SCRIPT_SRC;
        script.onload = resolve;
        script.onerror = function () {
          scriptPromise = null;
          reject(new Error("Babylist add.js failed to load"));
        };
        document.head.appendChild(script);
      });
    }

    return scriptPromise;
  }

  function normalizeUrl(value) {
    if (!value) return "";

    try {
      return new URL(value, window.location.href).href;
    } catch (error) {
      return value;
    }
  }

  function formatPrice(cents) {
    var numericCents = Number(cents);

    if (!Number.isFinite(numericCents)) return "";

    return (numericCents / 100).toFixed(2);
  }

  function addMetadata(list, key, value) {
    if (value === undefined || value === null || value === "") return;

    list.push({ key: key, value: String(value) });
  }

  function getTitle(button) {
    var productTitle = button.dataset.productTitle || "";
    var variantTitle = button.dataset.variantTitle || "";
    var hasOnlyDefaultVariant = button.dataset.hasOnlyDefaultVariant === "true";

    if (hasOnlyDefaultVariant || !variantTitle || variantTitle === "Default Title") {
      return productTitle;
    }

    return productTitle + " - " + variantTitle;
  }

  function getProductUrl(button) {
    var currentUrl = new URL(window.location.href);
    var variantUrl = button.dataset.variantUrl || "";

    if (variantUrl) return normalizeUrl(variantUrl);

    if (button.dataset.variantId) {
      currentUrl.searchParams.set("variant", button.dataset.variantId);
    }

    return currentUrl.href;
  }

  function buildPayload(button) {
    var scrapedData = [];
    var image = normalizeUrl(button.dataset.image || "");
    var payload = {
      price: formatPrice(button.dataset.priceCents),
      title: getTitle(button),
      url: getProductUrl(button),
      scraped_data: scrapedData
    };

    if (image) {
      payload.images = image;
    }

    addMetadata(scrapedData, "gtin", button.dataset.gtin);
    addMetadata(scrapedData, "sku", button.dataset.sku);
    addMetadata(scrapedData, "brand", button.dataset.brand);
    addMetadata(scrapedData, "availability", button.dataset.availability);

    return payload;
  }

  function getVariantImage(variant) {
    if (!variant) return "";

    if (variant.featured_image) {
      if (typeof variant.featured_image === "string") return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }

    if (variant.featured_media && variant.featured_media.preview_image) {
      return variant.featured_media.preview_image.src || "";
    }

    return "";
  }

  function updateButtonFromVariant(button, variant) {
    if (!button || !variant) return;

    button.dataset.variantId = variant.id || "";
    button.dataset.variantTitle = variant.title || "";
    button.dataset.priceCents = variant.price || "";
    button.dataset.sku = variant.sku || "";
    button.dataset.gtin = variant.barcode || "";
    button.dataset.availability = variant.available ? "InStock" : "OutOfStock";

    if (variant.id) {
      var productUrl = new URL(button.dataset.productUrl || window.location.href, window.location.href);
      productUrl.searchParams.set("variant", variant.id);
      button.dataset.variantUrl = productUrl.href;
    }

    var variantImage = getVariantImage(variant);

    if (variantImage) {
      button.dataset.image = normalizeUrl(variantImage);
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(BUTTON_SELECTOR);

    if (!button) return;

    event.preventDefault();

    if (button.getAttribute("aria-busy") === "true") return;

    button.setAttribute("aria-busy", "true");

    loadBabylist(button.dataset.partner)
      .then(function () {
        window.bl.addToRegistry(buildPayload(button));
      })
      .catch(function () {
        /* Script blocked or offline — leave the page usable */
      })
      .finally(function () {
        button.removeAttribute("aria-busy");
      });
  });

  document.addEventListener("variant:change", function (event) {
    var detail = event.detail || {};
    var formId = detail.formId;
    var variant = detail.variant;

    if (!formId || !variant) return;

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      if (button.dataset.productFormId === formId) {
        updateButtonFromVariant(button, variant);
      }
    });
  });
})();
